import { sdkLogRing } from '@/lib/logger';
import { littlebirdSdk } from '@/lib/sdk-init';
import {
  formatSyncSection,
  formatSyncLogsSection,
} from '@/utils/feedback-report-format';

import { uploadTextFileToS3 } from '../app-logs/app-logs.utils';

export async function uploadSyncReport(): Promise<string[]> {
  const status = await littlebirdSdk.getSyncStatus().catch(() => null);
  const report =
    formatSyncSection(status) + formatSyncLogsSection(sdkLogRing.lines());
  if (!report) return [];

  try {
    const timestamp = new Date().toISOString().replace(/[:.]/g, '-');
    return [await uploadTextFileToS3(report, `sync-report-${timestamp}`)];
  } catch (error) {
    console.error('Failed to upload sync report:', error);
    return [];
  }
}
